export default __webpack_public_path__ + "static/media/listview_inactive.cf29762e.svg";